import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['Tso'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTsoById: build.query<GetTsoByIdApiResponse, GetTsoByIdApiArg>({
        query: (queryArg) => ({ url: `/Tso/${queryArg}` }),
        providesTags: ['Tso'],
      }),
      getTsoGetAll: build.query<GetTsoGetAllApiResponse, GetTsoGetAllApiArg>({
        query: () => ({ url: `/Tso/get-all` }),
        providesTags: ['Tso'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as tsoApi };
export type GetTsoByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTsoExternalDto;
export type GetTsoByIdApiArg = number;
export type GetTsoGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTsoExternalDto;
export type GetTsoGetAllApiArg = void;
export type ApiCommonExternalDtoTsoExternalDto = {
  id?: number;
  name: string;
  abbreviation: string;
  tenantId?: string;
  isLoggedInUsersTso?: boolean;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoTsoExternalDto = {
  externalDto?: ApiCommonExternalDtoTsoExternalDto;
  externalDtos?: ApiCommonExternalDtoTsoExternalDto[] | null;
};
export const { useGetTsoByIdQuery, useLazyGetTsoByIdQuery, useGetTsoGetAllQuery, useLazyGetTsoGetAllQuery } =
  injectedRtkApi;
